import React, { useEffect, useState } from "react";
import { TEAMDETAIL } from "../../../utils/constants/apiUrl";
import { post } from "../../../server";
import { loggedInUser, teamIDCheck } from "../../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../Loader";
import showToast from "../../../helpers/showToast";
import _ from "lodash";
import { Button, Card } from "react-bootstrap";
const CancelSubscription = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  const [subscription, setSubscription] = useState({
    auto_renew: false,
  });

  const [loading, setLoading] = useState(false);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);

  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.currentTarget.checked;
    setSubscription({ ...subscription, [name]: value });
  };

  const handleSubmit = async (e) => {
    let subscriptionObj = subscription;
    subscriptionObj.team_id = userTeamId;
    setLoading(true);
    let { status, message } = await post(
      `${TEAMDETAIL}/autoRenew`,
      subscriptionObj,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    let userData = _.cloneDeep(loggedUser);
    userData.teams.auto_renew = subscriptionObj.auto_renew;
    setLoggedUser(userData);
    showToast(status, message);
    setLoading(false);
  };

  useEffect(() => {
    setSubscription({
      auto_renew: loggedUser?.teams?.auto_renew,
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Card className="notificationWrapper bioDataWrapper">
        <Card.Body>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="switchWrapper mb-3">
                <h6>Auto Subscription</h6>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    name="auto_renew"
                    checked={subscription.auto_renew}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <p>
                After your subscription is cancelled, this will automatically be
                removed if your auto subscription is active.
              </p>
            </div>
          </div>
          <Button
            type="button"
            className="mt-4"
            onClick={handleSubmit}
            variant="primary"
          >
            Update Subscription
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default CancelSubscription;
